import { Form } from 'antd';

import { SList } from 'app/components/StaycationUI/List';
import { useGetExperiencesByHotelId } from 'app/hooks/data/core/admin/hotels/useHotelExperiences';
import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import type { PackResponse } from 'app/typings/core/admin/packs/pack';

import './ExperienceList.scss';
import { ExperienceListItem } from './ExperienceListItem/ExperienceListItem';
import { useExperienceListLogic } from './useExperienceListLogic';

export const ExperienceList = () => {
  const form = Form.useFormInstance<
    Partial<PackResponse> & { experiences: ExperienceResponse[] }
  >();
  const packExperiences = Form.useWatch('packExperiences', form);
  const hotelId = Form.useWatch('hotelId', form);

  const { data: hotelExperiences } = useGetExperiencesByHotelId(hotelId, {
    withStaycationExperiences: true,
  });

  const experienceIds = packExperiences?.map(
    (packExperience) => packExperience.experienceId
  );

  const isNotIncludedOvernightExperiences =
    hotelExperiences?.experiences?.filter(
      (exp) => !exp.isAlwaysIncludedWithNight && experienceIds?.includes(exp.id)
    ) ?? [];

  const { createToggleExperienceHandler } = useExperienceListLogic({ form });

  return (
    <Form.Item name="packExperiences" className="experience-list-container">
      <div className="discover-list-experiences-container">
        <div className="staycation-discover-card__title">Experiences</div>
        <div className="discover-list-experiences">
          <SList
            grid={{ gutter: 16, column: 1 }}
            data={isNotIncludedOvernightExperiences}
            renderItem={(item) => {
              const packExperienceIndex =
                packExperiences?.findIndex(
                  (pe) => pe.experienceId === item.id
                ) ?? -1;

              return (
                <ExperienceListItem
                  experience={item}
                  key={item.id}
                  onToggle={createToggleExperienceHandler(item)}
                  packExperienceIndex={packExperienceIndex}
                />
              );
            }}
          />
        </div>
      </div>
    </Form.Item>
  );
};
